<template>
  <div class="cashcreation">
    <div class="header-text" :style="{ width: ElementHeight }">
      <h1 class="header-title">积分商城商品管理—查看（礼品）</h1>
      <div class="buttom-div">
        <el-button class="push-button" @click="Searchtid"
          >查看兑换记录</el-button
        >
        <el-button
          style="color: #a19b59"
          icon="iconfont icon-fanhui"
          @click="backHistory"
          >返回</el-button
        >
      </div>
    </div>
    <div class="header-text1"></div>
    <div>
      <el-card shadow="never" class="card-center" style="margin-top: 10px">
        <!-- 表单 -->
        <div>
          <el-form
            size="small"
            :label-position="labelPosition"
            label-width="100px"
          >
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="礼品">
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.giftName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="商品名称">
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.commodityName"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="礼品券库">
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.couponsName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9" style="margin-top: 50px; margin-left: -38%">
                <el-form-item label="商品详情">
                  <editor v-model="ruleForm.commDetail" :min-height="192" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9" style="width: 50%">
                <el-form-item label="封面图">
                  <img
                    width="45%"
                    v-for="(item, index) in imagesArray"
                    :key="index"
                    :src="item"
                    style="margin: 10px"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="9"> </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="颜色">
                  <el-checkbox-group v-model="colorcheckList">
                    <el-checkbox
                      name="type"
                      :disabled="true"
                      v-for="(item, index) in colorList"
                      :key="index"
                      :label="item.index"
                      >{{ item.colorAttrName }}
                      <div style="width: 100%"></div>
                      <img
                        width="50%"
                        :disabled="true"
                        :src="item2"
                        v-for="(item2, index2) in item.imgList"
                        :key="index2"
                        style="margin: 10px"
                      />
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="18">
                <el-form-item label="SKU">
                  <el-table
                    size="mini"
                    class="table-style"
                    border
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{
                      background: '#FCFBF2',
                      color: '#6C6839',
                      'text-align': 'center',
                    }"
                    :cell-style="{ 'text-align': 'center' }"
                    ref="multipleTable"
                    :data="SkuList"
                    tooltip-effect="dark"
                  >
                    <el-table-column label width="35" type="index">
                    </el-table-column>
                    <el-table-column prop="productSKU" label="礼品SKU">
                      <template slot-scope="scope">
                        <div
                          style="text-decoration: underline; color: #76734f"
                          @click="handleGoods(scope.row)"
                        >
                          {{ scope.row.productSKU }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="colorName" label="颜色">
                    </el-table-column>
                    <el-table-column prop="sizeName" label="尺码">
                    </el-table-column>
                    <el-table-column prop="stockQty" label="库存数量">
                    </el-table-column>
                    <el-table-column prop="redeemedQty" label="已兑换数量">
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="吊牌价">
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.lblPrice"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="领取方式">
                  <el-checkbox-group
                    v-model="ruleForm.collectMethod"
                    :disabled="true"
                  >
                    <el-checkbox :label="1"> 到店自取</el-checkbox>
                    <el-checkbox :label="2">快递邮寄</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="领取期限">
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.deadLine"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="最大兑换数量">
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.maxNum"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="兑换日期">
                  <el-row>
                    <el-col :span="11">
                      <el-date-picker
                        type="date"
                        placeholder=""
                        v-model="ruleForm.startDate"
                        style="width: 100%"
                        :disabled="true"
                      ></el-date-picker>
                    </el-col>
                    <el-col class="line" style="text-align: center" :span="2"
                      >至</el-col
                    >
                    <el-col :span="11">
                      <el-date-picker
                        type="date"
                        placeholder=""
                        v-model="ruleForm.endDate"
                        style="width: 100%"
                        :disabled="true"
                      ></el-date-picker>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="兑换积分">
                  <el-input
                    v-model="ruleForm.creditPoint"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="限制销售等级">
                  <el-checkbox
                    label="限制"
                    name="type"
                    v-model="ruleForm.allUser"
                    :disabled="true"
                  >
                  </el-checkbox>
                  <el-checkbox-group v-model="checkedCities" :disabled="true">
                    <div style="width: 200px; border: 1px solid #ccc">
                      <div style="margin-left: 20px">
                        <div>
                          <el-checkbox
                            v-for="item in checkList"
                            :key="item.levelID"
                            :label="item.levelID"
                          >
                            {{ item.levelName_cn }}
                          </el-checkbox>
                        </div>
                      </div>
                    </div>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="置顶排序">
                  <el-checkbox-group v-model="ruleForm.top" :disabled="true">
                    <div class="flex-between">
                      <el-checkbox name="type">置顶</el-checkbox>
                      <el-input
                        style="margin-left: 10px"
                        :disabled="true"
                        v-model="ruleForm.topSortIndex"
                      ></el-input>
                    </div>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="允许兑换维护店" label-width="120px">
                  <el-radio-group
                    v-model="ruleForm.allServShop"
                    :disabled="true"
                  >
                    <div style="display: flex; align-items: center">
                      <el-radio :label="true">全部门店</el-radio>
                      <el-radio :label="false">部分门店</el-radio>
                    </div>
                  </el-radio-group>
                  <div style="padding-top: 20px" v-if="!ruleForm.allServShop">
                    <textarea
                      style="width: 100%; margin: 0px; padding: 0px"
                      :disabled="true"
                      rows="4"
                      readonly
                      v-model="ruleForm.servOrgListStr"
                    ></textarea>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="核销提醒方">
                  <el-radio-group
                    v-model="ruleForm.pubVeriCoupMode"
                    :disabled="true"
                  >
                    <el-radio :label="0">不提醒</el-radio>
                    <el-radio :label="1">公众号模板消息</el-radio>
                    <el-radio :label="2">短信消息</el-radio>
                    <el-radio :label="3">公众号模板消息和短信消息</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="券到期提醒方">
                  <el-radio-group
                    v-model="ruleForm.expirationMode"
                    :disabled="true"
                  >
                    <el-radio :label="0">不提醒</el-radio>
                    <el-radio :label="1">公众号模板消息</el-radio>
                    <el-radio :label="2">短信消息</el-radio>
                    <el-radio :label="3">公众号模板消息和短信消息</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="提前提醒">
                  <el-input
                    style="width: 100px"
                    :disabled="true"
                    v-model="ruleForm.expirationTime"
                  ></el-input
                  >&nbsp;天
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="18">
                <el-form-item label="领取场所限制">
                  <el-radio-group v-model="ruleForm.siteLimitFlag">
                    <el-radio :label="0" :disabled="true">无限制</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="">
                  <el-radio-group v-model="ruleForm.siteLimitFlag">
                    <el-radio :label="2" :disabled="true">城市</el-radio>
                  </el-radio-group>
                  <el-table
                    size="mini"
                    class="table-style"
                    border
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{
                      background: '#FCFBF2',
                      color: '#6C6839',
                      'text-align': 'center',
                    }"
                    :cell-style="{ 'text-align': 'center' }"
                    ref="multipleTable"
                    :data="cityList"
                    tooltip-effect="dark"
                  >
                    <el-table-column label width="35" type="index">
                    </el-table-column>
                    <el-table-column prop="siteName" label="城市">
                    </el-table-column>
                    <el-table-column prop="hasStock" label="是否有库存">
                      <template scope="scope">
                        <el-checkbox
                          :checked="scope.row.hasStock"
                          :disabled="true"
                        ></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column prop="State" label="状态">
                      <template slot-scope="scope">
                        <el-checkbox
                          :checked="scope.row.state === 0 ? true : false"
                          :disabled="true"
                        ></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          @click.native.prevent="
                            deletebtnSer(scope.$index, cityList)
                          "
                          :disabled="true"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="18">
                <el-form-item label="">
                  <el-radio-group v-model="ruleForm.siteLimitFlag">
                    <el-radio :label="1" :disabled="true">门店</el-radio>
                  </el-radio-group>
                  <el-table
                    size="mini"
                    class="table-style"
                    border
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{
                      background: '#FCFBF2',
                      color: '#6C6839',
                      'text-align': 'center',
                    }"
                    :cell-style="{ 'text-align': 'center' }"
                    ref="multipleTable"
                    :data="shopList"
                    tooltip-effect="dark"
                  >
                    <el-table-column label width="35" type="index">
                    </el-table-column>
                    <el-table-column prop="siteName" label="门店">
                    </el-table-column>
                    <el-table-column prop="shopName" label="门店名称">
                    </el-table-column>
                    <el-table-column prop="hasStock" label="是否有库存">
                      <template scope="scope">
                        <el-checkbox
                          :checked="scope.row.hasStock"
                          :disabled="true"
                        ></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column prop="state" label="状态">
                      <template slot-scope="scope">
                        <el-checkbox
                          :checked="scope.row.state === 0 ? true : false"
                          :disabled="true"
                        ></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          @click.native.prevent="
                            deletebtnshop(scope.$index, shopList)
                          "
                          :disabled="true"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
    <!-- 产品信息详情查看弹窗-->
    <div class="found">
      <el-dialog
        width="60%"
        title="产品详细信息"
        :visible.sync="foundFormVisible"
        :close-on-click-modal="false"
      >
        <el-form
          size="mini"
          label-width="80px"
          :model="formLabeladd"
          ref="resberValidateForm"
          style="margin-top: 20px"
        >
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="SKU">
                <el-input
                  v-model="formLabeladd.sku"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品编码">
                <el-input
                  placeholder=""
                  v-model="formLabeladd.productCode"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="SKU描述中文">
                <el-input
                  v-model="formLabeladd.skudesc_CN"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品中文描述">
                <el-input
                  placeholder=""
                  v-model="formLabeladd.productName_CN"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="SKU描述英文">
                <el-input
                  placeholder=""
                  v-model="formLabeladd.skudesc_EN"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品名称英文" prop="otherReason">
                <el-input
                  placeholder=""
                  v-model="formLabeladd.productName_EN"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="SKU描述意大利" prop="realChgDate">
                <el-input
                  placeholder=""
                  v-model="formLabeladd.skudesc_IT"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品名称意大利" prop="remark">
                <el-input
                  v-model="formLabeladd.productName_IT"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="品牌编号" prop="remark">
                <el-input
                  v-model="formLabeladd.brandNo"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品描述" prop="remark">
                <el-input
                  v-model="formLabeladd.description"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="种类编号" prop="remark">
                <el-input
                  v-model="formLabeladd.familyID"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="类别编号" prop="remark">
                <el-input
                  v-model="formLabeladd.categoryID"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="类别" prop="remark">
                <el-input
                  v-model="formLabeladd.category_cn"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="款号编号" prop="remark">
                <el-input
                  v-model="formLabeladd.styleID"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="类别英文" prop="remark">
                <el-input
                  v-model="formLabeladd.category_en"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="款号附加位编号" prop="remark">
                <el-input
                  v-model="formLabeladd.styleAddnCode"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品线编号" prop="remark">
                <el-input
                  v-model="formLabeladd.lineID"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="主成份编号" prop="remark">
                <el-input
                  v-model="formLabeladd.mainCompID"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="成份" prop="remark">
                <el-input
                  v-model="formLabeladd.composition_cn"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="颜色编号" prop="remark">
                <el-input
                  v-model="formLabeladd.colorID"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="成份英文" prop="remark">
                <el-input
                  v-model="formLabeladd.composition_en"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="季号" prop="remark">
                <el-input
                  v-model="formLabeladd.seasonID"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="尺码模板编号" prop="remark">
                <el-input
                  v-model="formLabeladd.sizeTemplateID"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="附加信息编码" prop="remark">
                <el-input
                  v-model="formLabeladd.addnCode"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="模板名称" prop="remark">
                <el-input
                  v-model="formLabeladd.templateName_cn"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="图像文件名" prop="remark">
                <el-input
                  v-model="formLabeladd.imgFileName1"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="模板名称英文" prop="remark">
                <el-input
                  v-model="formLabeladd.templateName_en"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="图像文件名2" prop="remark">
                <el-input
                  v-model="formLabeladd.imgFileName2"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设计师编号" prop="remark">
                <el-input
                  v-model="formLabeladd.designerID"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="大类" prop="remark">
                <el-input
                  v-model="formLabeladd.zdl"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设计师姓名" prop="remark">
                <el-input
                  v-model="formLabeladd.designerName"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="细类" prop="remark">
                <el-input
                  v-model="formLabeladd.zxlbm"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="系列" prop="remark">
                <el-input
                  v-model="formLabeladd.zxl"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="组别" prop="remark">
                <el-input
                  v-model="formLabeladd.groupLvl"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别(产品)" prop="remark">
                <el-input
                  v-model="formLabeladd.zwldl"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产地" prop="remark">
                <el-input
                  v-model="formLabeladd.wherl"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="货币ID" prop="remark">
                <el-input
                  v-model="formLabeladd.currencyID"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态" prop="remark">
                <el-select
                  v-model="formLabeladd.state"
                  style="width: 100%"
                  :disabled="true"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="款色编码" prop="remark">
                <el-input
                  v-model="formLabeladd.styleColorCode"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建人员" prop="createUserID">
                <el-input
                  v-model="formLabeladd.createUserName"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建时间">
                <el-time-picker
                  v-model="formLabeladd.createTime"
                  :disabled="true"
                  style="width: 100%"
                  format="yyyy-mm-dd:hh:mm"
                >
                </el-time-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="修改人员" prop="updateUserID">
                <el-input
                  v-model="formLabeladd.updateUserName"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="修改时间" prop="remark">
                <el-time-picker
                  v-model="formLabeladd.updateTime"
                  :disabled="true"
                  style="width: 100%"
                  format="yyyy-mm-dd:hh:mm"
                >
                </el-time-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
    </div>
    <!-- 查看兑换记录弹窗 -->
    <div class="record">
      <el-dialog width="60%" title="查看兑换记录" :visible.sync="recordVisible">
        <div class="buttonClass">
          <el-button
            icon="iconfont icon-chakan1"
            @click="golookjump"
            style="border: 1px solid #b5b386"
            >查询</el-button
          >
          <el-button
            icon="iconfont icon-chakan1"
            @click="lookjump"
            style="border: 1px solid #b5b386; margin-left: 30px"
            >查看</el-button
          >
        </div>
        <div>
          <el-form size="mini" label-width="110px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="兑换记录编号">
                  <el-input v-model="giftListNo.redemptionNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商品类型">
                  <el-select v-model="giftListNo.commKind" style="width: 100%">
                    <el-option
                      v-for="item in optioncommkid"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="会员卡号\姓名">
                  <el-input v-model="giftListNo.search"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="兑换日期">
                  <el-date-picker
                    style="width: 40%"
                    type="date"
                    start-placeholder="开始日期"
                    value-format="yyyy-MM-dd"
                    v-model="giftListNo.startRedemptionTime"
                  >
                  </el-date-picker>
                  至
                  <el-date-picker
                    style="width: 50%; margin-left: 15px"
                    type="date"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    v-model="giftListNo.endRedemptionTime"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="POST领取单号">
                  <el-input v-model="giftListNo.getNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="领取方式">
                  <el-select
                    v-model="giftListNo.collectMethod"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in optionquery"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="状态">
                  <el-select v-model="giftListNo.state" style="width: 100%">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12"> </el-col>
            </el-row>
          </el-form>
          <el-table
            class="table-style"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="multipleTable"
            :data="delivery"
            tooltip-effect="dark"
            v-el-table-infinite-scroll="true"
            infinite-scroll-disabled="true"
          >
            <el-table-column label width="35">
              <template slot-scope="scope">
                <el-radio
                  v-model="radio"
                  :label="scope.$index"
                  @change.native="handleRadioChange(scope.row)"
                  >&nbsp;
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="redemptionNo" label="兑换记录编号">
            </el-table-column>
            <el-table-column prop="custName" label="会员"> </el-table-column>
            <el-table-column prop="creditPoint" label="商品积分">
            </el-table-column>
            <el-table-column prop="qty" label="兑换数量"> </el-table-column>
            <el-table-column prop="exchangeSumPoint" label="兑换总积分">
            </el-table-column>
            <el-table-column prop="redemptionTime" label="兑换日期">
              <template slot-scope="scope">
                {{ scope.row.redemptionTime | dateFormats }}
              </template>
            </el-table-column>
            <el-table-column prop="getTime" label="领取日期">
              <template slot-scope="scope">
                {{ scope.row.getTime | dateFormats }}
              </template>
            </el-table-column>
            <el-table-column prop="createUserName" label="创建人">
            </el-table-column>
            <el-table-column prop="createTime" label="创建日期">
              <template slot-scope="scope">
                {{ scope.row.createTime | dateFormats }}
              </template>
            </el-table-column>
            <el-table-column prop="updateUserName" label="最后修改人">
            </el-table-column>
            <el-table-column prop="updateTime" label="最后修改日期">
              <template slot-scope="scope">
                {{ scope.row.updateTime | dateFormats }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  upperOrLowerview,
  lntegralqueryApi,
  detailedCapi,
  customerlevelApi,
} from "@/api/Integralquery";
// import { UploadPictures } from '@/utils/constant'
export default {
  name: "centre",
  data() {
    return {
      screenWidth: "",
      ElementHeight: "0px",
      colorcheckList: [],
      colorList: [],
      labelPosition: "right",
      recordVisible: false,
      foundFormVisible: false,
      //详情页面绑定
      ruleForm: {
        commDetail: "", //商品详情
        commodityName: "", //商品名称
        expirationMode: "", //到期提醒方式
        pubVeriCoupMode: "", //核销提醒方式
        top: true,
        allUser: "",
        startDate: "", //开始
        endDate: "", //结束
        lblPrice: "", //吊牌价
        creditPoint: "", //兑换积分
        deadLine: "", //兑换后的领取期限
        collectMethod: "", //领取方式
        couponsName: "", //券库名称
        giftName: "", //礼品名称
        maxNum: "", //兑换最大数量
        expirationTime: "", //提前提醒天
        siteLimitFlag: "",
      },
      radio: "",
      //产品详细信息
      formLabeladd: {},
      //内置弹窗参数
      giftListNo: {
        pageNo: "1",
        pageSize: "50",
        commKind: "", //积分商品类型
        collectMethod: "", //领取方式
        getNo: "", //pos领取单号
        redemptionNo: "", //兑换编号
        search: "", //搜索内容
        startRedemptionTime: "", //开始兑换时间
        endRedemptionTime: "", //兑换结束时间
        state: "",
      },
      //城市列表
      cityList: [],
      //门店列表
      shopList: [],
      // sku
      SkuList: [],
      //内置弹框数据接受
      delivery: [],
      optionkid: [
        {
          value: 1,
          label: "到店自取",
        },
        {
          value: 2,
          label: "快递邮寄",
        },
        {
          value: 3,
          label: "到店自取和快递邮寄",
        },
      ],
      optioncommkid: [
        {
          value: "0",
          label: "礼券",
        },
        {
          value: "1",
          label: "礼品",
        },
        {
          value: "2",
          label: "券包",
        },
      ],
      optionquery: [
        {
          value: "1",
          label: "到店自取",
        },
        {
          value: "2",
          label: "快递邮寄",
        },
      ],
      options: [
        {
          value: 0,
          label: "未领取",
        },
        {
          value: 1,
          label: "已领",
        },
        {
          value: 2,
          label: "废弃",
        },
      ],
      commodityqs: "",
      checkList: [],
      checkedCities: [],
      changhandValue: "",
      imagesArray: [],
    };
  },
  created() {
    this.certificatevent();
    this.customermethods();
  },
  watch: {
    //窗口宽度变化
    screenWidth() {
      this.ElementHeight =
        document.querySelector(".cashcreation").offsetWidth + "px";
    },
  },
  mounted() {
    this.getELmentHeight();
  },
  methods: {
    getELmentHeight() {
      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
      };
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    backHistory() {
      this.$router.go(-1); //返回上一层
    },
    //数据查看赋值
    async certificatevent() {
      let arr = "";
      if (this.$route.query.come === undefined) {
        arr = this.$route.query.Gift;
      } else {
        arr = this.$route.query.come;
      }
      await upperOrLowerview({ commodityID: arr }).then((res) => {
        this.ruleForm = res.data;
        if (this.ruleForm.collectMethod == 3) {
          this.ruleForm.collectMethod = [1, 2];
        }
        if (this.ruleForm.collectMethod == 1) {
          this.ruleForm.collectMethod = [1];
        }
        if (this.ruleForm.collectMethod == 2) {
          this.ruleForm.collectMethod = [2];
        }
        this.commodityqs = this.$route.query.Gift;
        this.SkuList = res.data.tCommskustockList;

        this.colorList = res.data.commColorImgList;
        if (res.data.siteLimitFlag === 1) {
          this.shopList = res.data.shopList;
        }
        if (res.data.siteLimitFlag === 2) {
          this.cityList = res.data.cityList;
        }
        if (this.ruleForm.image1 != null) {
          this.imagesArray.push(this.ruleForm.image1);
        }
        if (this.ruleForm.image2 != null) {
          this.imagesArray.push(this.ruleForm.image2);
        }
        if (this.ruleForm.image3 != null) {
          this.imagesArray.push(this.ruleForm.image3);
        }
        this.colorList.forEach((item) => {
          item.imgList = [];
          if (item.image1 != null) {
            item.imgList.push(item.image1);
          }
          if (item.image2 != null) {
            item.imgList.push(item.image2);
          }
          if (item.image3 != null) {
            item.imgList.push(item.image3);
          }
        });
        this.ruleForm.servOrgListStr = "";
        this.ruleForm.servOrgList.forEach((item) => {
          this.ruleForm.servOrgListStr += `${item.shopName}\n`;
        });
        this.ruleForm.allUser = !this.ruleForm.allUser;
      });
      this.ruleForm.commAllowLvlList.forEach((item) => {
        if (item.selectOption === true) {
          this.checkedCities.push(item.levelID);
        }
      });
    },
    //删除功能
    deletebtnSer(index, rowes) {
      rowes.splice(index, 1);
    },
    //删除功能
    deletebtnshop(index, rowes) {
      rowes.splice(index, 1);
    },
    //内置弹窗数据
    async LookForecord() {
      let exChange = {
        pageNo: "1",
        pageSize: "50",
        commKind: this.giftListNo.commKind, //积分商品类型
        collectMethod: this.giftListNo.collectMethod, //领取方式
        getNo: this.giftListNo.getNo, //pos领取单号
        redemptionNo: this.giftListNo.redemptionNo, //兑换编号
        search: this.giftListNo.search, //搜索内容
        startRedemptionTime: this.giftListNo.startRedemptionTime, //开始兑换时间
        endRedemptionTime: this.giftListNo.endRedemptionTime, //兑换结束时间
        state: this.giftListNo.state,
        commodityID: this.ruleForm.commodityID,
      };
      await lntegralqueryApi(exChange).then((res) => {
        this.delivery = res.data.list;
      });
    },
    handleRadioChange(val) {
      this.changhandValue = val;
    },
    golookjump() {
      this.LookForecord();
    },
    async handleGoods(val) {
      await detailedCapi({ SKU: val.productSKU }).then((res) => {
        if (res.message == "success") {
          this.formLabeladd = res.data;
        }
        this.foundFormVisible = true;
      });
    },
    //内弹窗跳转
    lookjump() {
      console.log("123123", this.changhandValue);
      if (this.changhandValue == "") {
        this.$message("请选择记录查看!");
      } else {
        this.$router.push({
          path: "/PointsShopping",
          query: {
            restion: this.changhandValue.redemptionID,
          },
        });
      }
    },
    Searchtid() {
      this.LookForecord();
      this.recordVisible = true;
    },
    async customermethods() {
      await customerlevelApi().then((res) => {
        this.checkList = res.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.header-text {
  position: fixed;
  z-index: 88;
  margin-top: -1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  background-color: #f3f5f7;
  height: 4.5rem;
  color: #76734f;
  padding-bottom: 5px;
}
.card-pagination {
  height: 50px;
}
/deep/button {
  border: none;
  color: #a19b59;
}
// input框的圆角取消
/deep/input {
  border-radius: 0 !important;
}
//改变Upload 上传组件大小
/deep/ .el-upload--picture-card {
  width: 100px;
  height: 100px;
}
/deep/ .el-upload {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .avatar {
  width: 100px;
  height: 100px;
}

::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }

  .choice,
  .present {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 12px !important;
    }

    /* Dialog对话框 公共部分样式 End*/

    .el-tabs__item {
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-button:hover {
      background-color: #b6b388;
    }
    .el-form-item__content {
      line-height: 0px;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .record {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 20px 50px 20px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
  }
  .buttonClass {
    color: #b5b386 !important;
    margin-left: 80%;
    margin-top: -10px;
    margin-bottom: 10px;
  }
  .found {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 0 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
.cashcreation {
  margin-bottom: 100px;
}
.push-button {
  width: 120px;
  color: #a19b59;
}
.buttom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: flex-end;
  width: 250px;
  height: 50px;
  align-content: center;
}
.header-title {
  min-width: 250px;
  line-height: 50px;
  height: 50px;
}
.header-text1 {
  height: 3.5rem;
}
</style>
